import { reportUrls } from '../utils/urlResolver';
import axios from '.';

export const getIndividualList = (params) => {
  return axios({
    method: 'get',
    url: reportUrls.individual.url,
    params,
  });
};
export const getIndividualSumary = (params) => {
  return axios({
    method: 'get',
    url: reportUrls.individual.summary,
    params,
  });
};
export const getIndividualCount = (params) => {
  return axios({
    method: 'get',
    url: reportUrls.individual.totalCountUrl,
    params,
  });
};
export const getBulkList = (params) => {
  return axios({
    method: 'get',
    url: reportUrls.bulk.url,
    params,
  });
};
export const getBulkCount = (params) => {
  return axios({
    method: 'get',
    url: reportUrls.bulk.totalCountUrl,
    params,
  });
};

export const generateMonthlyExport = (data) => {
  return axios({
    method: 'post',
    url: reportUrls.bulk.monthlyExport,
    data,
  });
};
export const getMonthlyExportStatus = (data) => {
  return axios({
    method: 'get',
    url: reportUrls.bulk.monthlyExportStatus,
    data,
  });
};
export const isSummaryTableAvailable = (params) => {
  return axios({
    method: 'get',
    url: reportUrls.bulk.checkSummaryTable,
    params,
  });
};
